// This icon file is generated automatically.
var PtoArrReloadOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 32 32", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M28.4 6.54l-1.75 1.38a13.12 13.12 0 102 12.58.25.25 0 00-.16-.32l-1.77-.61a.25.25 0 00-.32.15l-.18.46a10.7 10.7 0 01-5.72 5.73 10.68 10.68 0 01-8.37 0 10.67 10.67 0 01-5.71-5.73 10.7 10.7 0 010-8.37 10.7 10.7 0 015.71-5.72 10.68 10.68 0 018.37 0 10.67 10.67 0 014.28 3.29l-1.88 1.46c-.17.13-.1.4.1.44l5.48 1.35c.16.04.31-.08.31-.24l.03-5.66c0-.2-.25-.32-.41-.19z", "fill-rule": "nonzero" } }] }, "name": "pto-arr-reload", "theme": "outlined" };
export default PtoArrReloadOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PtoArrReloadOutlined.js
// module id = 3877
// module chunks = 0